import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from '../../dialogs/dialog.service';
import { LoggerService } from '../../providers/logger.service';
import * as $ from 'jquery'
import { ActivatedRoute, Router } from '@angular/router';
import { PublicapiV1Service } from '../../providers/publicapi.v1.service';
import {
  wrapperGetLogoUrlInApp, wrapperSwitchServerSessionStorageParams, wrapperGetBaseHrefForServer
} from '../../javascript.js';
import { Location } from '@angular/common';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.css']
})
export class EditComponent implements OnInit {

  token: any //$routeParams['token'];
  clientId: number //$routeParams['clientId'];
  grayscale: any //$routeParams['grayscale'];
  showdlbtn: any //$routeParams['showdlbtn'];
  serverId: any //$routeParams['serverId'];

  page: any //$routeParams['page'];
  pagecount: any //$routeParams['pagecount'];

  messageTitle = "";
  messageText = "";

  error = false;

  searchParams: any = [];
  searchParam: any;

  constructor(private translateService: TranslateService,
    private apiV1: PublicapiV1Service,
    private route: ActivatedRoute,
    private router: Router,
    private logger: LoggerService,
    private location: Location) { }

  ngOnInit(): void {
    this.setLogoUrl();

    this.token = this.route.snapshot.params['token'];
    this.clientId = this.route.snapshot.params['clientId'];
    this.grayscale = this.route.snapshot.queryParams['grayscale'];
    this.showdlbtn = this.route.snapshot.queryParams['showdlbtn'];

    this.serverId = this.route.snapshot.params['serverId'];
    if (this.serverId !== undefined && this.serverId !== null) {
      let baseHrefForServerParm = wrapperGetBaseHrefForServer(this.serverId);
      wrapperSwitchServerSessionStorageParams(baseHrefForServerParm);
    }

    this.page = this.route.snapshot.queryParams['page'];
    this.pagecount = this.route.snapshot.queryParams['pagecount'];

    this.apiV1.checkToken(this.token, this.clientId).then(
      data => {
        if (data === undefined || data['status'] !== 0) {
          console.debug("CHECK TOKEN FAILED", data);
          this.error = true;
          this.messageTitle = this.translateService.instant('Error');
          this.messageText = this.translateService.instant('ErrorClickBack');
          this.logger.write2log("EditController.init", "checkToken failed", "E");
          return;
        }
        // Now prepare the document
        this.apiV1.prepareDocumentFromToken(this.clientId, this.token, this.grayscale, this.page).then(
          data => {

            if (data !== undefined && data['status'] === 0) {
              this.searchParams = { token: this.token };
              if (this.grayscale) this.searchParams['grayscale'] = 'true';
              if (this.page) this.searchParams['page'] = this.page;
              if (this.pagecount) this.searchParams['pagecount'] = this.pagecount;
              if (this.showdlbtn) this.searchParams['showdlbtn'] = this.showdlbtn;
              var path = "/gallery/" + encodeURIComponent(data['document']) + "/" + encodeURI(data['page']);
              this.router.navigate([path], { queryParams: this.searchParams });
            } else {
              this.error = true;
              this.messageTitle = this.translateService.instant('Error');
              this.messageText = this.translateService.instant('ErrorClickBack');
              this.logger.write2log("EditController.init", "prepareDocumentFromToken failed", "E");
            }

          }
        );


      }
    );
  }

  setLogoUrl() {
    try {
      $("#van-logo").attr("href", wrapperGetLogoUrlInApp());
    } catch (e) {
    }
  }
}
